import React from 'react';
import { MainContainer, CardContainer, IconWrapper, ContentWrapper, Title, Description } from './style-component';
import smileyIcon from '@/assets/icons/smiley/smiley.svg';

export type ChallengeType = 'SOCIAL_MEDIA' | 'SURVEY' | 'EXCHANGE' | 'DEFAULT';

interface CongratulateCardProps {
    type?: ChallengeType;
    className?: string;
}

const CHALLENGE_MESSAGES: Record<ChallengeType, { title: string; description: string }> = {
    SOCIAL_MEDIA: {
        title: "¡Felicidades!",
        description: "Has alcanzado todos los objetivos, ya puedes redimir tu recompensa. "
    },
    SURVEY: {
        title: "¡Gracias por compartir tus respuestas!",
        description: "Ya puedes redimir tu recompensa."
    },
    EXCHANGE: {
        title: "¡Felicidades!",
        description: "Ya adquiriste este coleccionable."
    },
    DEFAULT: {
        title: "¡Felicitaciones!",
        description: "Has completado exitosamente esta misión"
    }
};

const CongratulateCard: React.FC<CongratulateCardProps> = ({
    type = 'DEFAULT',
    className
}) => {
    const message = CHALLENGE_MESSAGES[type];

    return (
        <MainContainer className={className}>
            <CardContainer>
                <IconWrapper>
                    <img src={smileyIcon} alt="Congratulations" />
                </IconWrapper>
                <ContentWrapper>
                    <Title>{message.title}</Title>
                    <Description>{message.description}</Description>
                </ContentWrapper>
            </CardContainer>
        </MainContainer>
    );
};

export default CongratulateCard;
